import React, { Component } from 'react';
import './App.css';
import AuthService from './components/AuthService';
import withAuth from './components/withAuth';
import Footer from './components/Footer';
import Main from './components/Main';
import appTitle from './images/AST-Logo-Main-Nav-003.png'; 


const Auth = new AuthService();

class App extends Component {
  state = {

  }

  render() {
    return (
      <div className="App">
        <div className="App-header">
          <div className="App-title"><img src={appTitle} alt="logo" /></div>
            <div className="App-logout">
              <button type="button" className="form-submit" onClick={this.handleLogout.bind(this)}>Logout</button>
            </div>
          <div className="App-break"></div>
        </div>
        <div className="App-divider"></div>
        <div>
          <Main />
        </div>
        <div>
          <Footer />
        </div>
      </div>
    );
  }

  //clear the token from local storage
  handleLogout() {
    Auth.logout()
    localStorage.removeItem('options');
    this.props.history.replace('/login');
  }

}

export default withAuth(App);





// WEBPACK FOOTER //
// ./src/App.js